import React from 'react'
import { Container, Row } from 'reactstrap'
import PageHeader from '../../../../shared/components/PageHeader'
import BudgetMonthlyPreviewPage from './components/BudgetMonthlyPreviewPage'

export default function BudgetMonthlyPreview() {
  return (
    <Container>
      <Row>
        <PageHeader
          title="Budget Monthly Preview"
          subhead="Preview computed monthly budgets for all active budget groups. Select a month to see projected spend."
        />
      </Row>
      <Row>
        <BudgetMonthlyPreviewPage />
      </Row>
    </Container>
  )
}

